export default {"src":"/blog/_next/static/media/wordmark_black.af3afac2.svg","height":82,"width":81,"blurWidth":0,"blurHeight":0};